import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../Helper/Context/context";
import { useEffect, useState } from "react";
import { AgeDDL } from "../../../CommonDDL/AgeDDL";
import { EducationDDL } from "../../../CommonDDL/EducationDDL";
import { MemberINHHDDL } from "../../../CommonDDL/MemberINHHDDL";
import { GenderNameDDL } from "../../../CommonDDL/GenderNameDDL";
import { LivelihoodSourceDDLData } from "../../../CommonDDL/LivelihoodSourceDDLData";
import { UnitNameDDL } from "../../../CommonDDL/UnitNameDDL";
import { PlotCodeDDL } from "../../../CommonDDL/PlotCodeDDL";
import AddMaterialPackagingPopup from "./AddMaterialPackagingPopup/AddMaterialPackagingPopup";
import AddCreditLinkagePopup from "./AddCreditLinkagePopup/AddCreditLinkagePopup";
import { BeneficiaryDetailsPopUpTableDataAPI, BeneficiaryDetailsPostAPI } from "../../../../Helper/Redux/AdminDashboardSlice/BeneficiaryDetailsSlice";
import { Loading } from "../../../../Helper/LogoLoader/LogoLoader";
import { AstricSign } from "../../../../Helper/AstricSign";
import { PlantingMaterialReceivedFromDDL } from "../../../CommonDDL/PlantingMaterialReceivedFromDDL";
import { PlantingMaterialPaymentDDL } from "../../../CommonDDL/PlantingMaterialPaymentDDL";
import PlantingMaterialPackaging from "./PlantingMaterialPackaging";
import CreditLinkageSection from "./CreditLinkageSection";


const BeneficiaryDetailsViewPopup = (props) => {

    const { handleShowAddModal, handleIsPost, ShowAddModal, IsClear, setIsClear, YearValue, MonthValue, Title } = props
    const { flag, data } = ShowAddModal

    const userDetails = useAuthState();
    const { UserID, token } = userDetails
    const dispatch = useDispatch()

    const [AddMaterialPopup, setAddMaterialPopup] = useState(false)
    const [CreditLinkagePopup, setCreditLinkagePopup] = useState(false)

    const [BeneficiaryDetails, setBeneficiaryDetails] = useState([])
    const [BeneficiaryPackaging, setBeneficiaryPackaging] = useState([])
    const [CreditLinkage, setCreditLinkage] = useState([])

    const [RadioValue, setRadioValue] = useState('')
    const [RadioValueIntrested, setRadioValueIntrested] = useState('')
    const [RadioMaterialPayment, setRadioMaterialPayment] = useState("yes")
    const [RadioMaterialPackaging, setRadioMaterialPackaging] = useState('yes')
    const [RadioCreditLinkage, setRadioCreditLinkage] = useState('')

    const [TotalLandArea, setTotalLandArea] = useState('')
    const [UnitID, setUnitID] = useState('0')
    const [UnitName, setUnitName] = useState('')
    const [NoOfPlots, setNoOfPlots] = useState('')
    const [PlotCodeID, setPlotCodeID] = useState('')
    const [PlotCodeName, setPlotCodeName] = useState('')

    const [Monthlyincome, setMonthlyincome] = useState('')
    const [DataIsPost, setDataIsPost] = useState(false)
    const [IsCreditLinkageData, setIsCreditLinkageData] = useState(false)
    const [NoOfPlant, setNoOfPlant] = useState('')
    const [furtherPlantation, setfurtherPlantation] = useState('')
    const [DistanceFromNursery, setDistanceFromNursery] = useState('')
    const [NurseryName, setNurseryName] = useState('')

    useEffect(() => {
        setMonthlyincome(flag == 'Update' ? BeneficiaryDetails && BeneficiaryDetails[0]?.monthlyIncome : '')
        setTotalLandArea(flag == 'Update' ? BeneficiaryDetails && BeneficiaryDetails[0]?.totalLandArea : '')
        setUnitID(flag == 'Update' ? BeneficiaryDetails && BeneficiaryDetails[0]?.m_UnitID : '0')
        setUnitName(flag == 'Update' ? BeneficiaryDetails && BeneficiaryDetails[0]?.m_Unit : '')
        setNoOfPlots(flag == 'Update' ? BeneficiaryDetails && BeneficiaryDetails[0]?.no_of_Plots : '')
        setNoOfPlant(flag == 'Update' ? BeneficiaryDetails && BeneficiaryDetails[0]?.totalPlantation_NoOfPlants : '')
        setfurtherPlantation(flag == 'Update' ? BeneficiaryDetails && BeneficiaryDetails[0]?.furtherPlantation_NoOfPlants : '')
        setDistanceFromNursery(flag == 'Update' ? BeneficiaryDetails && BeneficiaryDetails[0]?.distanceFromNursery : '')
        setNurseryName(flag == 'Update' ? BeneficiaryDetails && BeneficiaryDetails[0]?.nurseryName : '')
        setRadioValue(BeneficiaryDetails && BeneficiaryDetails[0]?.totalPlantation_M_IndicatorID)
        setRadioValueIntrested(BeneficiaryDetails && BeneficiaryDetails[0]?.furtherPlantation_M_IndicatorID)
        setRadioMaterialPayment(BeneficiaryDetails && BeneficiaryDetails[0]?.plantMaterialPayment_M_IndicatorID)
        setRadioCreditLinkage(BeneficiaryDetails && BeneficiaryDetails[0]?.creditLinkage_M_IndicatorID)
    }, [BeneficiaryDetails])

    const [AgeID, setAgeID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [GenderID, setGenderID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [EducationID, setEducationID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [MemberINHHID, setMemberINHHID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [LivelihoodSourceID, setLivelihoodSourceID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    // const [TotalLandAreaID, setTotalLandAreaID] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",
    // })
    // const [PlotCodeID, setPlotCodeID] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",
    // })

    const [MaterialReceivedFromID, setMaterialReceivedFromID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [PlantingMaterialPaymentDDLID, setPlantingMaterialPaymentDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    // const handleDataIsPost = () => {
    //     handleShowAddModal(false, '')
    //     setShowDeletePopup(false)
    //     setIsPost(!IsPost)
    // }


    useEffect(() => {
        const data = {
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            M_TableUserMasterID: UserID,
            Flag: "BeneficiaryDetails",
            token: token,
            setBeneficiaryDetails: setBeneficiaryDetails,

        }
        dispatch(BeneficiaryDetailsPopUpTableDataAPI({ data }))

    }, [])

    useEffect(() => {
        const data = {
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            M_TableUserMasterID: UserID,
            Flag: "BeneficiaryPackaging",
            token: token,
            setBeneficiaryPackaging: setBeneficiaryPackaging

        }
        dispatch(BeneficiaryDetailsPopUpTableDataAPI({ data }))

    }, [DataIsPost])

    useEffect(() => {
        const data = {
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            M_TableUserMasterID: UserID,
            Flag: "BeneficiaryCreditLinkage",
            token: token,
            setCreditLinkage: setCreditLinkage

        }
        dispatch(BeneficiaryDetailsPopUpTableDataAPI({ data }))

    }, [IsCreditLinkageData])

    const { isLoading } = useSelector(state => state.BeneficiaryDetailsPopUpTableData)

    const handleAddCreditLinkage = () => {
        setCreditLinkagePopup(!CreditLinkagePopup)
    }

    const handleSubmit = () => {
        const data = {
            FinancialYearID: YearValue,
            MonthsID: MonthValue,
            M_BeneficiaryDetailsID: ShowAddModal.data.m_BeneficiaryDetailsID,
            SurveyDate: '',
            Age_M_IndicatorID: AgeID.ID,
            Gender_M_IndicatorID: GenderID.ID,
            Education_M_IndicatorID: EducationID.ID,
            MembersInHH_M_IndicatorID: MemberINHHID.ID,
            LiveliHood_M_IndicatorID: LivelihoodSourceID.ID,
            MonthlyIncome: Monthlyincome,
            TotalLandArea: TotalLandArea,
            No_of_Plots: NoOfPlots,
            M_UnitID: UnitID,
            TotalPlantation_M_IndicatorID: RadioValue,
            FurtherPlantation_M_IndicatorID: RadioValueIntrested,
            ReceivedFromID: MaterialReceivedFromID.ID,
            DistanceFromNursery: DistanceFromNursery,
            NurseryName: NurseryName,
            PlantMaterialPayment_M_IndicatorID: RadioMaterialPayment,
            CreditLinkage_M_IndicatorID: RadioCreditLinkage,
            M_BeneficiaryPlotCode: 0,
            Flag: "Online",
            M_TableUserMasterID: UserID,
            token: token,
            handleIsPost

        }
        dispatch(BeneficiaryDetailsPostAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.BeneficiaryDetailsPostData)

    return (
        <>
            {isLoading ? <Loading /> :
                <div className="modal fade show d-flex align-items-center" style={{ display: "block", backgroundColor: "#00000055" }}>
                    <div className="modal-dialog modal-xl " style={{ minWidth: '80vw' }} role="document"  >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title fw-bold text-danger modal-title-fs" id="exampleModalLongTitle">{Title}</h5>
                                <button onClick={() => handleShowAddModal(false, '')} type="button" className="close" style={{ marginLeft: "auto" }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{ overflowY: 'scroll', height: '70vh' }}>
                                <div className="row">
                                    <div className="col-xl-4 col-lg-3 pt-2 mt-3 mt-lg-0 pt-lg-2 ">
                                        <AgeDDL
                                            AgeID={AgeID}
                                            setAgeID={setAgeID}
                                            apiFlag='Master'
                                            Flag={flag}
                                            data={BeneficiaryDetails && BeneficiaryDetails[0]}
                                            IsPost=''
                                            AstricSignFlag="AstricSign"

                                        />

                                    </div>

                                    <div className="col-xl-4 col-lg-3 pt-2 mt-3 mt-lg-0 pt-lg-2 ">
                                        <GenderNameDDL
                                            GenderID={GenderID}
                                            setGenderID={setGenderID}
                                            apiFlag='Master'
                                            Flag={flag}
                                            data={BeneficiaryDetails && BeneficiaryDetails[0]}
                                            IsPost=''
                                            AstricSignFlag="AstricSign"
                                        />

                                    </div>

                                    <div className="col-xl-4 col-lg-3 pt-2 mt-3 mt-lg-0 pt-lg-2 ">
                                        <EducationDDL
                                            EducationID={EducationID}
                                            setEducationID={setEducationID}
                                            apiFlag='Master'
                                            Flag={flag}
                                            data={BeneficiaryDetails && BeneficiaryDetails[0]}
                                            IsPost=''
                                            AstricSignFlag="AstricSign"

                                        />
                                    </div>

                                    <div className="col-xl-4 col-lg-3 pt-2 mt-3 mt-lg-0 pt-lg-0">
                                        <MemberINHHDDL
                                            MemberINHHID={MemberINHHID}
                                            setMemberINHHID={setMemberINHHID}
                                            apiFlag='Master'
                                            Flag={flag}
                                            data={BeneficiaryDetails && BeneficiaryDetails[0]}
                                            IsPost=''
                                            AstricSignFlag="AstricSign"

                                        />

                                    </div>

                                    <div className="col-xl-4 col-lg-3 pt-2 mt-3 mt-lg-0 pt-lg-0 ">

                                        <LivelihoodSourceDDLData
                                            LivelihoodSourceID={LivelihoodSourceID}
                                            setLivelihoodSourceID={setLivelihoodSourceID}
                                            apiFlag='Master'
                                            Flag={flag}
                                            data={BeneficiaryDetails && BeneficiaryDetails[0]}
                                            IsPost=''
                                            AstricSignFlag="AstricSign"

                                        />

                                    </div>

                                    <div className="col-xl-4 col-lg-3 pt-2 mt-3 mt-lg-0 pt-lg-0 ">
                                        <div className="form-group m-0">
                                            <span className="fw-bold ">Avg.Monthly income (Rs) <AstricSign/></span>
                                            <input
                                                type="text"
                                                className="form-control mt-2"
                                                name="DepartmentName"
                                                placeholder={Monthlyincome}
                                                value={Monthlyincome}
                                                onChange={(e) => setMonthlyincome(e.target.value)}


                                            />
                                        </div>
                                    </div>

                                    <div className="col-xl-4 col-lg-4 pt-2 mt-3 mt-lg-0 pt-lg-2">

                                        {/* <div className="col-12 col-md-5"> */}
                                        <div className="col-12">
                                            <label for="exampleInputEmail1" className="form-label"> Total Land Area (Unit) <AstricSign /></label>
                                        </div>
                                        {/* </div> */}

                                        <div className="col-12">
                                            <div className="col-12">
                                                <div className="input-group ">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="TotalLandArea"
                                                        value={TotalLandArea}

                                                        onChange={(e) => setTotalLandArea(e.target.value)}
                                                    />

                                                    <span className="input-group-text">
                                                        <UnitNameDDL
                                                            UnitID={UnitID}
                                                            setUnitID={setUnitID}
                                                            UnitName={UnitName}
                                                            setUnitName={setUnitName}
                                                            apiFlag='Master'
                                                            Flag={flag}
                                                            data={BeneficiaryDetails && BeneficiaryDetails[0]}
                                                            IsPost=''

                                                        />


                                                    </span>
                                                    {/* {
                                                            IsValidDecimalNo && <text style={{ color: 'red' }}>Please enter Numbers only</text>
                                                        } */}

                                                </div>
                                            </div>

                                        </div>
                                        {/* 
                                        <UnitNameDDL
                                            UnitID={TotalLandAreaID}
                                            setUnitID={setTotalLandAreaID}
                                            apiFlag='Master'
                                            Flag={flag}
                                            data={tableData && tableData[0]}
                                            IsPost=''
                                            UnitFlag='TotalLandAreaID'
                                            AstricSignFlag="AstricSign"
                                        /> */}

                                    </div>

                                    <div className="col-xl-4 col-lg-3 pt-2 mt-3 mt-lg-0 pt-lg-2 my-2">


                                        {/* <div className="col-12 col-md-5"> */}
                                        <div className="col-12">
                                            <label for="exampleInputEmail1" className="form-label"> No Of Plots (Plots) <AstricSign /></label>
                                        </div>
                                        {/* </div> */}

                                        <div className="col-12">
                                            <div className="col-12">
                                                <div className="input-group ">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="NoOfPlots"
                                                        value={NoOfPlots}

                                                        onChange={(e) => setNoOfPlots(e.target.value)}
                                                    />

                                                    <span className="input-group-text">
                                                        <PlotCodeDDL
                                                            PlotCodeID={PlotCodeID}
                                                            setPlotCodeID={setPlotCodeID}
                                                            PlotCodeName={PlotCodeName}
                                                            setPlotCodeName={setPlotCodeName}
                                                            apiFlag='All'
                                                            Flag={flag}
                                                            data={BeneficiaryDetails && BeneficiaryDetails[0]}
                                                            M_BeneficiaryDetailsID={ShowAddModal.data.m_BeneficiaryDetailsID}
                                                            IsPost=''

                                                        />


                                                    </span>
                                                    {/* {
                                                      IsValidDecimalNo && <text style={{ color: 'red' }}>Please enter Numbers only</text>
                                                  } */}

                                                </div>
                                            </div>
                                        </div>
                                        {/* <PlotCodeDDL
                                            PlotCodeID={PlotCodeID}
                                            setPlotCodeID={setPlotCodeID}
                                            apiFlag='APK_BeneficiaryDetails'
                                            Flag={flag}
                                            data={tableData && tableData[0]}
                                            IsPost=''
                                            AstricSignFlag="AstricSign"
                                            M_BeneficiaryDetailsID={ShowAddModal.data.m_BeneficiaryDetailsID}
                                        /> */}

                                    </div>

                                    <div className="col-xl-4 col-lg-3 pt-2 mt-3 mt-lg-0 pt-lg-2 my-2">

                                        <PlantingMaterialReceivedFromDDL
                                            MaterialReceivedFromID={MaterialReceivedFromID}
                                            setMaterialReceivedFromID={setMaterialReceivedFromID}
                                            apiFlag='Master'
                                            Flag={flag}
                                            data={BeneficiaryDetails && BeneficiaryDetails[0]}
                                            IsPost=''
                                            AstricSignFlag="AstricSign"

                                        />

                                    </div>

                                    <div className="col-xl-4 col-lg-3 pt-2 mt-3 mt-lg-0 pt-lg-2 my-4">
                                        <span className="fw-bold ">Do you have old Plantation <AstricSign/></span>
                                        <div className="pt-2 text-start">

                                            <span className="pe-3">
                                                <input type="radio" onChange={() => setRadioValue('53')} id='53' name={RadioValue == 53} value="53" checked={RadioValue == 53 && "checked"} />
                                                <label for="huey">Yes</label>
                                            </span>

                                            <span>
                                                <input type="radio" onChange={() => setRadioValue('54')} id="54" name={RadioValue == 54} value="54" checked={RadioValue == 54 && "checked"} />
                                                <label for="dewey">No</label>
                                            </span>
                                        </div>
                                        {
                                            RadioValue == "53" ?


                                                <div className="form-group m-0">
                                                    <span className="text-dark">No of Plant </span>
                                                    <input
                                                        type="text"
                                                        className="form-control mt-2"
                                                        name="NoOfPlant"
                                                        placeholder="value"
                                                        value={NoOfPlant}
                                                        onChange={(e) => setNoOfPlant(e.target.value)}


                                                    />
                                                </div>

                                                :
                                                ''
                                        }

                                    </div>

                                    <div className="col-xl-4 col-lg-3 pt-2 mt-3 mt-lg-0 pt-lg-2 my-4">
                                        <span className="fw-bold ">Interested in further Plantation<AstricSign/></span>
                                        <div className="pt-2 text-start">

                                            <span className="pe-3">
                                                <input type="radio" onChange={() => setRadioValueIntrested('53')} id='53' name={RadioValueIntrested == 53} value="53" checked={RadioValueIntrested == 53 && "checked"} />
                                                <label for="huey">Yes</label>
                                            </span>

                                            <span>
                                                <input type="radio" onChange={() => setRadioValueIntrested('54')} id="54" name={RadioValueIntrested == 54} value="54" checked={RadioValueIntrested == 54 && "checked"} />
                                                <label for="dewey">No</label>
                                            </span>
                                        </div>

                                        {
                                            RadioValueIntrested == "53" ?

                                                <div className="form-group m-0">
                                                    <span className="text-primary">No of Plant </span>
                                                    <input
                                                        type="text"
                                                        className="form-control mt-2"
                                                        name="DepartmentName"
                                                        placeholder="value"
                                                        value={furtherPlantation}
                                                        onChange={(e) => setfurtherPlantation(e.target.value)}

                                                    />
                                                </div>

                                                :
                                                ''
                                        }

                                    </div>

                                    <div className="col-xl-4 col-lg-3 pt-2 mt-3 mt-lg-0 pt-lg-2 my-4">
                                        <div className="form-group m-0">
                                            <span className="fw-bold ">Distance from Nursery (km) <AstricSign/></span>
                                            <input
                                                type="text"
                                                className="form-control mt-2"
                                                name="DepartmentName"
                                                placeholder=""
                                                value={DistanceFromNursery}
                                                onChange={(e) => setDistanceFromNursery(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-xl-4 col-lg-3 pt-2 mt-3 mt-lg-0 pt-lg-2 my-4">
                                        <div className="form-group m-0">
                                            <span className="fw-bold ">Nursery Name <AstricSign/></span>
                                            <input
                                                type="text"
                                                className="form-control mt-2"
                                                name="DepartmentName"
                                                placeholder=""
                                                value={NurseryName}
                                                onChange={(e) => setNurseryName(e.target.value)}

                                            />
                                        </div>
                                    </div>

                                    <div className="col-xl-5 col-lg-3 pt-2 mt-3 mt-lg-0 pt-lg-2 my-4">
                                        <span className="fw-bold ">Do you Pay anything for the planting material <AstricSign/></span>
                                        <div className="pt-2 text-start">

                                            <span className="pe-3">
                                                <input type="radio" onChange={() => setRadioMaterialPayment('53')} id='53' name={RadioMaterialPayment == 53} value="53" checked={RadioMaterialPayment == 53 && "checked"} />
                                                <label for="huey">Yes</label>
                                            </span>

                                            <span>
                                                <input type="radio" onChange={() => setRadioMaterialPayment('54')} id='54' name={RadioMaterialPayment == 54} value="54" checked={RadioMaterialPayment == 54 && "checked"} />
                                                <label for="dewey">No</label>
                                            </span>
                                        </div>
                                        {
                                            RadioMaterialPayment == "53" ?


                                                <div className="form-group m-0">
                                                    {/* <span className=" text-primary">xx</span> */}
                                                    <PlantingMaterialPaymentDDL
                                                        PlantingMaterialPaymentDDLID={PlantingMaterialPaymentDDLID}
                                                        setPlantingMaterialPaymentDDLID={setPlantingMaterialPaymentDDLID}
                                                        apiFlag='Master'
                                                        Flag={flag}
                                                        data={BeneficiaryDetails && BeneficiaryDetails[0]}
                                                        IsPost=''
                                                        AstricSignFlag="AstricSign"

                                                    />

                                                </div>

                                                :
                                                ''
                                        }

                                    </div>

                                    <PlantingMaterialPackaging
                                        BeneficiaryPackaging={BeneficiaryPackaging}
                                        M_BeneficiaryDetailsID={ShowAddModal.data.m_BeneficiaryDetailsID}
                                        DataIsPost={DataIsPost}
                                        setDataIsPost={setDataIsPost} />

                                    <CreditLinkageSection
                                        CreditLinkage={CreditLinkage}
                                        M_BeneficiaryDetailsID={ShowAddModal.data.m_BeneficiaryDetailsID}
                                        IsCreditLinkageData={IsCreditLinkageData}
                                        setIsCreditLinkageData={setIsCreditLinkageData}
                                        RadioCreditLinkage={RadioCreditLinkage}
                                        setRadioCreditLinkage={setRadioCreditLinkage} />

                                    {/* <div className="col-xl-6 col-lg-3 pt-2 mt-3 mt-lg-0 pt-lg-2 my-4">
                                        <span className="fw-bold ">Credit Linkage : </span>
                                        <span className="pt-2 text-start">

                                            <span className="px-3">
                                                <input type="radio" onChange={() => setRadioCreditLinkage('yes')} id="Yes" name="Value" value="Yes" />
                                                <label for="huey">Yes</label>
                                            </span>

                                            <span>
                                                <input type="radio" id="NO" onChange={() => setRadioCreditLinkage('No')} name="Value" value="NO" />
                                                <label for="dewey">No</label>
                                            </span>


                                            <span className=" add_button mx-3 px-3 py-1"
                                                onClick={() => handleAddCreditLinkage()} >
                                                <i class="fa-solid fa-plus"></i>  Add
                                            </span>
                                        </span>

                                    </div>


                                    {
                                        RadioCreditLinkage == "yes" ?
                                            <div className="col-12 pt-2 mt-3 mt-lg-0 pt-lg-0">
                                                <div className="table-responsive p-0" >
                                                    <table className="table table-bordered">
                                                        <thead>
                                                            <tr className=" text-white">
                                                                <th className="text-center">Sr. No.</th>
                                                                <th className="text-center">Credit Linkage</th>
                                                                <th className="text-center">Action</th>


                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            <tr>
                                                                <td align="center">1</td>
                                                                <td align="center">Input</td>

                                                                <td align="center"> <i className="fa fa-trash mx-2 text-danger v_icon_style"

                                                                    title="Do you want to delete this record?"></i>
                                                                </td>

                                                            </tr>

                                                        </tbody>
                                                    </table>

                                                </div>
                                            </div>

                                            :
                                            ''
                                    } */}


                                    <div className="col-12 ">
                                        <div className="form-group w-80 d-flex justify-content-center">
                                            <button
                                                type='button'
                                                onClick={handleSubmit}
                                                disabled={PlantingMaterialPaymentDDLID.ID == 0 || RadioMaterialPayment == "0"||NurseryName == '' || DistanceFromNursery == '' ||
                                                furtherPlantation == '' || RadioValueIntrested == '0' || NoOfPlant == '' || NoOfPlots == '' ||RadioValue == '' || MaterialReceivedFromID.ID == 0 || 
                                                UnitID == 0 || TotalLandArea == '' || Monthlyincome == '' || LivelihoodSourceID.ID == 0 || MemberINHHID.ID == 0 || EducationID.ID == 0 ||
                                                GenderID.ID == 0 || AgeID.ID == 0 }
                                                className="btn bg-success text-white border-2 mx-2 px-4" data-ktwizard-type="action-next">
                                                Update
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => handleShowAddModal(false, '')}
                                                className="btn btn-danger border-2" data-ktwizard-type="action-next">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>





                            </div>
                        </div>

                    </div>
                </div>

            }


        </>);
}

export default BeneficiaryDetailsViewPopup;